import { gql } from 'graphql-request';

const request = {
	request: {
		name: 'void'
	},

	gql: {
		schema: gql`
			query {
			  request {
					row_id
			  }
			}
		`
	}
};

export default request;
